import { Box, CssBaseline, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import MetaDecorator from "../services/meta_decorator";
import NDReferralHeader from "../components/shared/ndreferralheader";
import Footer from "../components/shared/footer";
import { bodyBg, footerContainer, fullHeight, headerText, pcolor } from "../style2";

export default function Resources() {
    const { orgCode } = useParams();
    
    return <Box sx={{ ...bodyBg, ...fullHeight }}>
        <CssBaseline />
        <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
        <NDReferralHeader orgCode={orgCode} logo="../../logo.jpg" />
        <Box pt={1} sx={{ ...bodyBg, marginTop: "5px" }} p={5}>
            <Typography variant="h5" sx={{ ...headerText, marginTop: "15px", fontWeight: "bold", fontSize: "2rem" }}>
                Resources
            </Typography>
            <Box><Typography sx={{ marginTop: "15px", fontWeight: "bold", fontSize: "1.4rem", color: pcolor }}>Neurodevelopmental (ND) Hubs - Derby and Derbyshire</Typography></Box>
            <Box sx={{ marginTop: "15px", fontSize: "1.2rem" }}>
                There are 4 Neurodiverse (ND) Community Hubs which can be found in South Derbyshire, Derby City, Central
                Derbyshire and High Peak.<br /><br />
                With no formal referral needed, the hubs will offer children, young people up to the age of 25, their families
                and carers drop-ins for advice and information, one to one sessions or groups via appointments, a space to
                work out how to manage their situation, support with the assessment process, before and after a diagnosis,
                training for parents and individuals, and specialist sessions covering housing, benefits, finance and
                employment.<br /><br />
                The hubs will also provide a safe and supportive environment where people can ask questions, be heard
                without having to repeat their story, receive hope and encouragement to reduce isolation.
            </Box>

            <Box>
                <Typography sx={{ marginTop: "15px", fontWeight: "bold", fontSize: "1.4rem", color: pcolor }}>Strategies to be followed in school to manage a child with severe Neurodevelopmental
                    Disorders such as Autism and/or ADHD</Typography>
            </Box>
        </Box>
        <Box sx={footerContainer}>
            <Footer />
        </Box>
    </Box>
}